export const LABELS = {
  urgent: { text: "Urgent", cls: "bg-rose-100 text-rose-800 border-rose-200" },
  "follow-up": { text: "Follow-up", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  fyi: { text: "FYI", cls: "bg-slate-100 text-slate-600 border-slate-200" },
};

export function labelConfig(l) {
  return LABELS[l] || { text: "Untriaged", cls: "bg-slate-100 text-slate-500 border-slate-200" };
}

export function initials(name = "") {
  return name.split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase();
}

export function relTime(iso) {
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function fmtTime(iso) {
  return new Date(iso).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
}

export function fmtDay(iso) {
  return new Date(iso).toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" });
}

export function fmtDayShort(iso) {
  return new Date(iso).toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
}

const AVATAR_COLORS = [
  "bg-emerald-100 text-emerald-700", "bg-indigo-100 text-indigo-700",
  "bg-amber-100 text-amber-700", "bg-rose-100 text-rose-700",
  "bg-sky-100 text-sky-700", "bg-violet-100 text-violet-700",
];
export function avatarColor(seed = "") {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = seed.charCodeAt(i) + ((h << 5) - h);
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
}
